<template>
    <div>
        <Paciente
            :paciente="data.additionals.paciente"
        />

        <rkm-row>
            <rkm-col>
                <rkm-form-select
                    disabled
                    :options="unidadesOptions"
                    label="Unidade Solicitante"
                    value-field="id"
                    v-model="model.internacaoHospitalar.unidadeSolicitanteId"
                    text-field="nomeFantasia"
                />
            </rkm-col>

        </rkm-row>

        <rkm-row>
            <rkm-col cols="4">
                <rkm-form-input-autocomplete
                    :repository="repositories.cid"
                    :search-fields="fields.autocompletes.cidPrincipal"
                    :validations="validations.cidPrincipal"
                    label="CID principal"
                    :text-field="(item) => `${item.codigo} - ${item.nome}`"
                    v-model="model.internacaoHospitalar.cidPrincipal"
                >
                    <template #itemLabel="{ item }">
                        {{ item.codigo | formatCid }} - {{ item.nome }}
                    </template>
                </rkm-form-input-autocomplete>
            </rkm-col>

            <rkm-col cols="4">
                <rkm-form-input-autocomplete
                    :repository="repositories.cid"
                    :search-fields="fields.autocompletes.cidSecundario"
                    :validations="validations.cidSecundario"
                    label="CID secundário"
                    :text-field="(item) => `${item.codigo} - ${item.nome}`"
                    v-model="model.internacaoHospitalar.cidSecundario"
                >
                    <template #itemLabel="{ item }">
                        {{ item.codigo | formatCid }} - {{ item.nome }}
                    </template>
                </rkm-form-input-autocomplete>
            </rkm-col>

            <rkm-col cols="4">
                <rkm-form-input-autocomplete
                    :repository="repositories.cid"
                    :search-fields="fields.autocompletes.cidCausasAssociadas"
                    :validations="validations.cidCausasAssociadas"
                    label="CID causas associadas"
                    :text-field="(item) => `${item.codigo} - ${item.nome}`"
                    v-model="model.internacaoHospitalar.cidCausasAssociadas"
                >
                    <template #itemLabel="{ item }">
                        {{ item.codigo | formatCid }} - {{ item.nome }}
                    </template>

                </rkm-form-input-autocomplete>
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col>
                <rkm-form-input
                    :value="diagnosticoInicial"
                    disabled
                    label="Diagnóstico inicial"
                    />

                <rkm-row>
                    <rkm-col>
                        <rkm-form-textarea
                            :validations="validations.principaisSinaisSintomasClinicos"
                            label="Principais sinais e sintomas clinicos"
                            rows="4"
                            v-model="model.internacaoHospitalar.principaisSinaisSintomasClinicos"
                            />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col>
                        <rkm-form-textarea
                            :validations="validations.condicoesQueJustificamInternacao"
                            label="Condições que justificam a internação"
                            rows="4"
                            v-model="model.internacaoHospitalar.condicoesQueJustificamInternacao"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col>
                        <rkm-form-textarea
                            :validations="validations.principaisResultadosDeProvasDiagnosticas"
                            label="Principais resultados de provas diagnósticas"
                            rows="4"
                            v-model="model.internacaoHospitalar.principaisResultadosDeProvasDiagnosticas"
                        />
                    </rkm-col>
                </rkm-row>

            </rkm-col>
        </rkm-row>

         <Procedimento
            :additionals="data.form.additionals"
            :cid="model.internacaoHospitalar.cidPrincipal ? model.internacaoHospitalar.cidPrincipal : null"
            :form="procedimentoForm"
            :model="model.internacaoHospitalar.procedimento"
        />

        <CausaExterna
            :additionals="data.form.additionals"
            :form="causaExternaForm"
            :model="model.internacaoHospitalar.causasExternas"
        />

        <Autorizacao
            :additionals="data.form.additionals"
            :form="autorizacaoForm"
            :model="model.internacaoHospitalar.autorizacao"
        />
    </div>
</template>


<script>
import Paciente from './components/paciente/Index'
import Procedimento from './components/procedimento/Form'
import CausaExterna from './components/causa-externa/Form'
import Autorizacao from './components/autorizacao/Form'

import formatFilters from '@/filters/formats'
import { repository } from '@/mixins'
export default {
    components:{ Paciente, Procedimento, CausaExterna, Autorizacao},
    computed:{

        procedimentoForm(){
            return this.data?.form?.encaminhamentoHospitalar?.procedimento ?? null
        },
        causaExternaForm(){
            return this.data?.form?.encaminhamentoHospitalar?.causaExterna ?? null
        },
        autorizacaoForm(){
            return this.data?.form?.encaminhamentoHospitalar?.autorizacao ?? null
        },
        fields() {

            return {
                autocompletes: {
                    cidPrincipal: [
                        { key: 'codigo', searchable: true },
                        { key: 'nome', searchable: true },
                    ],
                    cidSecundario: [
                        { key: 'codigo', searchable: true },
                        { key: 'nome', searchable: true },
                    ],
                    cidCausasAssociadas: [
                        { key: 'codigo', searchable: true },
                        { key: 'nome', searchable: true },
                    ],
                }
            }
        },
        validations() {
            return {
                unidadeSolicitante: { required: true },
                cidPrincipal: { required: true },
                cidSecundario: {},
                cidCausasAssociadas: {},
                principaisSinaisSintomasClinicos: { required: true, max: 1000 },
                condicoesQueJustificamInternacao: { required: true, max: 1000 },
                principaisResultadosDeProvasDiagnosticas: { required: true, max: 1000 },
            }
        },
        diagnosticoInicial(){
            return this.model.internacaoHospitalar.cidPrincipal ? this.model.internacaoHospitalar.cidPrincipal.nome : ''
        }
    },
    data:() => ({
        form:{
            procedimento: null,
        },
        additionals:{
            unidade: {
                id: null,
                nomeFantasia: null
            }
        },
        unidadesOptions:[]

    }),
    filters: {
        formatCid: formatFilters.formatCid,
    },
    created(){
        this.repositories = {
            cid: this.getConectaSusRepository('sigtap.cid')
        }
        this.load()
    },

    methods:{
        load(){
            const unidade = this.data.form.additionals.unidadeLogada
            this.model.internacaoHospitalar.unidadeSolicitanteId = unidade.id
            this.additionals.unidade.id = unidade.id
            this.additionals.unidade.nomeFantasia = unidade.nomeFantasia

            this.unidadesOptions = [{
                id: unidade.id,
                nomeFantasia: unidade.nomeFantasia
            }]


            if (!this.model.internacaoHospitalar.cidPrincipal) {
                this.model.internacaoHospitalar.cidPrincipal = this.data.cidSugestao
                    ? this.data.cidSugestao[0]
                    : null
            }
        },

    },
    mixins: [repository],
    props: {
        data: {required: true, type: Object},
        model: {required: true, type: Object},
    },

}


</script>